import React, { useContext, useEffect, useState } from "react";
import api from "../../../../utils/axios";
import {
  Box,
  Button,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  VStack,
} from "@chakra-ui/react";
import { Link as ReachLink } from "react-router-dom";
import { UserContext } from "../../../../context/UserContext";
import { hasPermission } from "../../../../utils/helpers";

function AdminManageLodging() {
  const { user, language } = useContext(UserContext);

  const [lodgings, setLodgings] = useState([]);

  function fetchReferenceData() {
    api.get("/api/lodgings").then((res) => {
      setLodgings(res.data);
    });
  }

  useEffect(() => {
    fetchReferenceData();
  }, []);

  async function handleDelete(d) {
    if (!hasPermission(user, "edit_reference_data_lodging")) {
      // eslint-disable-next-line no-alert
      alert("You do not have permissions to delete lodgings.");
      return;
    }

    if (
      // eslint-disable-next-line no-alert
      window.confirm("Are you sure you wish to delete this lodging?")
    ) {
      try {
        await api.delete(`/api/lodgings/${d._id}`);
        fetchReferenceData();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }

      // eslint-disable-next-line no-alert
      alert("Lodging deleted");
    }
  }

  return (
    <VStack spacing={5} marginBottom={10}>
      <Heading textAlign="center" margin="20px">
        {language === "en" ? "Reference Data" : "參考資料"}
      </Heading>
      <Heading as="h4" size="md">
        Lodgings
      </Heading>
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <Th>Lodging Name</Th>
              <Th>Date</Th>
              <Th></Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {lodgings &&
              lodgings.map((lodging) => (
                <Tr key={lodging._id}>
                  <Td>{lodging.name}</Td>
                  <Td>
                    {lodging.date
                      ? new Date(lodging.date).toISOString().split("T")[0]
                      : ""}
                  </Td>
                  <Td>
                    <Button
                      as={ReachLink}
                      to={
                        hasPermission(user, "edit_reference_data_lodging")
                          ? `/admin/reference-data/lodging/${lodging._id}`
                          : "#"
                      }
                      size="md"
                      colorScheme="yellow"
                      isDisabled={
                        !hasPermission(user, "edit_reference_data_lodging")
                      }
                    >
                      {language === "en" ? "Update" : "更新"}
                    </Button>
                  </Td>
                  <Td>
                    <Button
                      colorScheme="red"
                      onClick={() => handleDelete(lodging)}
                      isDisabled={
                        !hasPermission(user, "edit_reference_data_lodging")
                      }
                    >
                      Delete
                    </Button>
                  </Td>
                </Tr>
              ))}
          </Tbody>
        </Table>
      </TableContainer>
      <Box>
        <Button as={ReachLink} to="/admin/reference-data" margin="0px 20px">
          {language === "en" ? "Back" : "回上頁"}
        </Button>
        <Button
          as={ReachLink}
          to={
            hasPermission(user, "edit_reference_data_lodging")
              ? "/admin/reference-data/lodging/add"
              : "#"
          }
          colorScheme="blue"
          size="md"
          margin="0px 20px"
          isDisabled={!hasPermission(user, "edit_reference_data_lodging")}
        >
          {language === "en" ? "Add Lodging" : "加新的住宿"}
        </Button>
      </Box>
    </VStack>
  );
}

export default AdminManageLodging;
